enum EHEADER{
  HEADER_URL_ENCODE = "HEADER_URL_ENCODE",
  HEADER_JSON = "HEADER_JSON",
  HEADER_MULTIPART= "HEADER_MULTIPART"
}
export default EHEADER